import React from 'react';
import { Container, UnsafeHTML, Paper, TypographyHeading, TypographyStyler } from '@honeycomb/ui-core';
export function Headline({ header, details, __typename }) {
    return (React.createElement(Container, { "data-id": `section-${__typename}-root-component`, component: "section" },
        React.createElement(Paper, { p: 8, align: "center" },
            React.createElement(TypographyHeading, { size: "m" }, header),
            React.createElement(TypographyStyler, null,
                React.createElement(UnsafeHTML, null, details)))));
}
